import { formatDistance } from 'date-fns'
import { ru } from 'date-fns/locale'

export const getDateAgo = date =>
  (date && formatDistance(new Date(date), new Date(Date.now()), { locale: ru })) || ''
